var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('div',{class:['loader-castorama-c', { 'loader-castorama-c--overlay': _vm.overlay } ].concat( _vm.getBemModifiers()),attrs:{"id":_vm.uniqueIdOfLoader}},[_c('CastoC',{staticClass:"loader-castorama-c__icon"})],1)}
var staticRenderFns = []

export { render, staticRenderFns }